import React from 'react';

const BellActive = (props) => {
    return (
        <svg
        viewBox="-43 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M413.418 360.813c-32.254-27.266-50.75-67.118-50.75-109.336V192c0-75.07-55.766-137.215-128-147.625V21.332C234.668 9.535 225.109 0 213.332 0 201.559 0 192 9.535 192 21.332v23.043C119.742 54.785 64 116.93 64 192v59.477c0 42.218-18.496 82.07-50.945 109.503A37.272 37.272 0 000 389.332c0 20.59 16.746 37.336 37.332 37.336h352c20.59 0 37.336-16.746 37.336-37.336 0-10.922-4.758-21.246-13.25-28.52zm0 0M213.332 512c38.637 0 70.957-27.543 78.379-64H134.953c7.426 36.457 39.746 64 78.379 64zm0 0" />
      </svg>
    )
}

export default BellActive;
